import { render, staticRenderFns } from "./classic-editor.vue?vue&type=template&id=1f04bd6e&scoped=true"
import script from "./classic-editor.vue?vue&type=script&lang=ts"
export * from "./classic-editor.vue?vue&type=script&lang=ts"
import style0 from "./classic-editor.vue?vue&type=style&index=0&id=1f04bd6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f04bd6e",
  null
  
)

export default component.exports